module.exports = __webpack_public_path__ + "img/lock.168ac09e.svg";